// grabbing auth context
import {AuthContext} from '../context/AuthContext'

// This is what we will use to consume the context
import {useContext} from 'react'

export const useAuthContext = () => {

    //  This is the context
    const context = useContext(AuthContext)

    // This will never happen
    if(!context){
        throw Error("useAuthContext must be used inside an AuthContectProvider")
    }

    return context;

}